import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=902d1ca8&scoped=true&"
import script from "./KpiCard.vue?vue&type=script&lang=js&"
export * from "./KpiCard.vue?vue&type=script&lang=js&"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=902d1ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902d1ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('902d1ca8')) {
      api.createRecord('902d1ca8', component.options)
    } else {
      api.reload('902d1ca8', component.options)
    }
    module.hot.accept("./KpiCard.vue?vue&type=template&id=902d1ca8&scoped=true&", function () {
      api.rerender('902d1ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/KpiCard.vue"
export default component.exports